// eslint-disable-next-line @typescript-eslint/no-empty-function
export function assertUnreachable(_x) {}

//# sourceMappingURL=assertUnreachable.js.map